import { ImageOptions_ObjectFit, ImageOptions_Ratio } from 'app/core/cms/generated/api-types'

export type AspectRatio = `${number} / ${number}`

// does not keep auto --> returns null instead
export function parseImgOptsRatio(ratio: ImageOptions_Ratio | null | undefined): AspectRatio | null {
  return ratio && ratio !== 'auto' ? (ratio.replace('_', '').replace('_', ' / ') as AspectRatio) : null
}

function isCmsAspectRatioNonAuto(val: string): val is `_${number}_${number}` {
  return val.startsWith('_')
}

// keeps auto
export function normalizeRatio(val: AspectRatio | ImageOptions_Ratio | null | undefined): AspectRatio | 'auto' | null {
  return val ? (isCmsAspectRatioNonAuto(val) ? parseImgOptsRatio(val) : val) : null
}

export type ObjectFit = 'contain' | 'cover'
export function defaultObjectFit(val: ImageOptions_ObjectFit | null | undefined): ObjectFit {
  return val ? val : 'cover'
}
